import React from 'react';
import Form from 'components/form';
import ProductInput from 'components/input/ProductInput';

export default function ProductField(props) {
  return <Form.Field {...props} component={ProductInput} />;
}
